import { RegionGeneratedEntity } from "./generated/RegionGeneratedEntity";

export abstract class RegionEntity extends RegionGeneratedEntity {
    // Comment to preserve new line

    get deepChildrenRegions(): RegionEntity[] {
        return this.childrenRegions.flatMap((child) => [child, ...child.deepChildrenRegions]);
    }
}
